import script from "./template-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./template-form.vue?vue&type=script&lang=ts&setup=true"

import "./template-form.vue?vue&type=style&index=0&id=c0589c08&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0589c08"]])

export default __exports__